<template>

  <input-holder :inlinerows="inlinerows" :inlinerowclasses="inlinerowclasses" :label="label" :inlineLabelClass="inlineLabelClass" :inlineInputClass="inlineInputClass" error="">
    <b-form-checkbox v-model="status" :class="checkboxClass" :name="name" @input="onInput" :value="checkedValue" :unchecked-value="uncheckedValue">
      <span v-if="defaultText" class="checkbox-default-text"> {{ defaultText }} </span>
      <slot> </slot>
      <br v-if="secondaryText" />
      <span v-if="secondaryText" class="checkbox-secondary-text"> {{ secondaryText }} </span>
      <small class="input-error" v-if="error">{{ error }}</small>
    </b-form-checkbox>
  </input-holder>

  <!--
  <div :class="inlinerows == 'true' ? inlinerowclasses + ' row' : inlinerowclasses">
    <label v-if="label" for="exampleFormControlInput1" :class="inlinerows == 'true' ? inlineLabelClass + ' col-form-label' : 'form-label'">{{ label }}</label>
    <div :class="inlinerows == 'true' ? inlineInputClass : label ? '' : 'col-md-12'">
    
    
      <b-form-checkbox v-model="status" :class="checkboxClass" :name="name" @input="onInput" :value="checkedValue" :unchecked-value="uncheckedValue">
        <span v-if="defaultText" class="checkbox-default-text"> {{ defaultText }} </span>
        <slot> </slot>
        <br v-if="secondaryText" />
        <span v-if="secondaryText" class="checkbox-secondary-text"> {{ secondaryText }} </span>
      </b-form-checkbox>

      <small class="input-error" v-if="error">{{ error }}</small>
    </div>
  </div>
-->
</template>

<script>
import "../../assets/scss/checkbox.scss";

import InputHolder from "./InputHolder.vue";

export default {
  name: "my-checkbox",
  data() {
    return {
      status: "not_accepted",
    };
  },
  components: {
    InputHolder,
  },
  methods: {
    onInput() {
      this.$emit("input", this.status);
    },
  },
  props: {
    inlinerows: {
      // type: Boolean,
      default: false,
    },
    inlinerowclasses: {
      default: "mb-3",
    },
    label: {
      type: String,
    },
    inlineLabelClass: {
      default: "col-sm-2",
    },
    inlineInputClass: {
      default: "col-sm-10",
    },
    error: {
      type: String,
      default: "",
    },

    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    readOnly: {
      default: false,
    },
    defaultText: {
      default: "",
    },
    secondaryText: {
      default: "",
    },
    checkedValue: {
      type: String,
      required: true,
    },
    uncheckedValue: {
      type: String,
      required: true,
    },
    checkboxClass: {
      default: "checkbox-branded",
    },
  },
};
</script>
